import React from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import DualListEventSelect from "./DualListEventSelect";
import EnableSyslogProcessingField from "./EnableSyslogProcessingField";
import AddEventKeyword from "./AddEventKeyword";

function AddDeviceStep3Content({ enableSyslogProcessing, selectedEvents }) {
    return (
        <form className="oct_form oct_form-label-center pt-4 px-4 modal-v2-form modal-v2-form-step3" autoComplete="off">
            {/* <div className="oct_form-title modal-v2-title">Add Device Wizard - STEP 3: Syslog Configuration</div> */}

            <div className="modal-v2-step3-shell">
                <div className="modal-v2-step3-toggle-wrap">
                    <EnableSyslogProcessingField />
                </div>

                {enableSyslogProcessing ? (
                    <div className="modal-v2-step3-events-panel">
                        <div className="modal-v2-step3-toolbar">
                            <div className="modal-v2-step3-toolbar-copy">
                                <div className="modal-v2-step3-toolbar-title">Event Monitoring</div>
                                <div className="modal-v2-step3-toolbar-help">
                                    Select the syslog events that should be monitored for this device.
                                </div>
                            </div>
                            <AddEventKeyword />
                        </div>

                        <DualListEventSelect />

                        <div className="modal-v2-step3-selection-summary">
                            {selectedEvents.length
                                ? `${selectedEvents.length} event${selectedEvents.length === 1 ? "" : "s"} selected for monitoring.`
                                : "No events selected yet."}
                        </div>
                    </div>
                ) : (
                    <div className="modal-v2-step3-empty-state">
                        Enable syslog processing to choose which events should trigger monitoring and alerting.
                    </div>
                )}
            </div>
        </form>
    );
}

function mapStateToProps(state) {
    debug("AddDeviceStep3 mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;

    return {
        enableSyslogProcessing: addDeviceModal.enableSyslogProcessing || false,
        selectedEvents: addDeviceModal.selectedEvents || []
    };
}

export const AddDeviceStep3 = connect(mapStateToProps)(AddDeviceStep3Content);
